import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import { KTBSDropdownDirections } from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useOnClickOutside from 'hooks/useOnClickOutside';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

DriverCustomerFilterDropdown.propTypes = {
  selectedDriver: PropTypes.object,
  onChange: PropTypes.func,
  direction: PropTypes.string,
};

function DriverCustomerFilterDropdown({
  selectedDriver,
  onChange,
  direction = KTBSDropdownDirections.down,
}) {
  const [show, setShow] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const ref = useRef();

  useOnClickOutside(ref, () => {
    if (show) {
      setShow(false);
    }
  });

  const handleSearch = async (text) => {
    setSearchKeyword(text);
    if (!text?.trim()) {
      setDrivers([]);
      return;
    }
    setLoading(true);
    try {
      const data = await ChargeHelper.API.Driver.requestGetDriverList({
        page: 0,
        limit: 10,
        q: text,
      });
      setDrivers(data?.drivers || []);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectDriver = (driver) => {
    onChange?.({
      id: driver?.userId,
      name: driver?.fullname,
      email: driver?.email,
      item: driver,
    });
    setShow(false);
  };

  const handleClearSelection = () => {
    onChange?.(null);
    setSearchKeyword('');
    setDrivers([]);
    setShow(false);
  };

  return (
    <div className="position-relative w-100" ref={ref}>
      <button
        className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
        type="button"
        onClick={() => setShow(!show)}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {selectedDriver?.name ?? 'Tất cả'}
      </button>

      {show && (
        <div
          className="position-absolute bg-white shadow w-100"
          style={{
            borderRadius: '5px',
            border: `1px solid ${AppColors.gray[300]}`,
            zIndex: 9999,
            top: direction === KTBSDropdownDirections.up ? 'auto' : '100%',
            bottom: direction === KTBSDropdownDirections.up ? '100%' : 'auto',
            marginTop: direction === KTBSDropdownDirections.up ? 0 : '4px',
            marginBottom: direction === KTBSDropdownDirections.up ? '4px' : 0,
          }}
        >
          <div className="p-3">
            <KTFormSearch
              name="driverCustomerFilter_search"
              placeholder="Theo tên khách hàng, email"
              value={searchKeyword}
              onSubmit={handleSearch}
            />
          </div>

          <div className="overflow-auto" style={{ maxHeight: '280px' }}>
            {loading ? (
              <div className="py-4 text-center" style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                Đang tìm kiếm...
              </div>
            ) : !searchKeyword?.trim() ? (
              <div className="d-flex flex-column align-items-center justify-content-center gap-3 py-4 px-3">
                <img src={imgEmptyNoData} style={{ maxWidth: '120px', maxHeight: '120px' }} alt="" />
                <span
                  className="text-center"
                  style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}
                >
                  Vui lòng nhập chính xác tên hoặc email của khách hàng để tìm kiếm.
                </span>
              </div>
            ) : drivers.length > 0 ? (
              drivers.map((driver) => {
                const isSelected = selectedDriver?.id === driver?.userId;
                return (
                  <div
                    key={driver?.userId}
                    className="d-flex align-items-center justify-content-between px-4 py-3 cursor-pointer bg-hover-light"
                    onClick={() => handleSelectDriver(driver)}
                  >
                    <div className="d-flex flex-column">
                      <span style={UIHelper.buildFontStyle('500', '14px', AppColors.gray[800])}>
                        {driver?.fullname}
                      </span>
                      {Utils.isValid(driver?.email) && (
                        <span style={UIHelper.buildFontStyle('400', '13px', AppColors.gray[600])}>
                          {driver?.email}
                        </span>
                      )}
                    </div>
                    {isSelected && <i className="fa-regular fa-check text-success" />}
                  </div>
                );
              })
            ) : (
              <div className="d-flex flex-column align-items-center justify-content-center gap-3 py-4 px-3">
                <img src={imgEmptyNoData} style={{ maxWidth: '120px', maxHeight: '120px' }} alt="" />
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                  Không tìm thấy khách hàng phù hợp.
                </span>
              </div>
            )}
          </div>

          {selectedDriver && (
            <div
              className="p-3"
              style={{
                borderTop: `1px solid ${AppColors.gray[300]}`,
              }}
            >
              {UIHelper.buildNegativeButton('Bỏ chọn', handleClearSelection)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DriverCustomerFilterDropdown;
